import { ReactComponent as LinkIcon } from '../../assets/link.svg';
import useCopyTestLink from '../../hooks/useCopyTestLink';
import WidgetButton from '../WidgetButton';

type Props = {
  testId: string;
  onOpenSnackbar?: (message: string) => void;
};

const CopyTestLinkButton = ({ testId, onOpenSnackbar }: Props) => {
  const handleCopy = useCopyTestLink(testId, onOpenSnackbar);

  return (
    <WidgetButton onClick={handleCopy} startIcon={<LinkIcon />}>
      Copy link
    </WidgetButton>
  );
};

export default CopyTestLinkButton;
